/* CAMODE product size guide: on-page modal, accessible controls, no route change. */
(function () {
  "use strict";
  if (window.__cmProductSizeGuideModalV1) return;
  window.__cmProductSizeGuideModalV1 = true;

  function initialize() {
    var trigger = document.querySelector("[data-cm-pg-open]");
    var dialog = document.getElementById("cm-product-size-modal");
    if (!trigger || !dialog) return;
    document.body.appendChild(dialog);

    var scrollbox = dialog.querySelector("[data-cm-pg-scroll]");
    var closeButton = dialog.querySelector(".cm-pg-guide-return");
    var priorFocus = null;
    var oldOverflow = null;
    var guidePromise = null;

    function openDialog() {
      if (dialog.open) return;
      priorFocus = document.activeElement;
      oldOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = "hidden";
      if (typeof dialog.showModal === "function") {
        dialog.showModal();
      } else {
        dialog.setAttribute("open", "");
      }
      if (closeButton) closeButton.focus({ preventScroll: true });
      showGuide(trigger.getAttribute("data-cm-pg-anchor") || "misure");
    }

    function finishClose() {
      document.documentElement.style.overflow = oldOverflow === null ? "" : oldOverflow;
      if (priorFocus && typeof priorFocus.focus === "function") {
        priorFocus.focus({ preventScroll: true });
      }
    }

    function closeDialog() {
      if (!dialog.open) return;
      if (typeof dialog.close === "function") {
        dialog.close();
      } else {
        dialog.removeAttribute("open");
        finishClose();
      }
    }

    function getGuide() {
      if (!guidePromise) {
        guidePromise = fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/") + "pages/guida-alle-taglie", { credentials: "same-origin" })
          .then(function (response) {
            if (!response.ok) throw new Error("Guide HTTP " + response.status);
            return response.text();
          })
          .then(function (html) {
            var documentGuide = new DOMParser().parseFromString(html, "text/html");
            var content = documentGuide.querySelector("#cm-sg");
            if (!content) throw new Error("Size guide content not found");
            return content;
          })
          .catch(function (error) {
            guidePromise = null;
            throw error;
          });
      }
      return guidePromise;
    }

    function scrollToGuideSection(id) {
      if (!/^(cm-sg|cm-sg-[a-z0-9-]+)$/.test(id)) return;
      var target = scrollbox.querySelector("#" + id);
      if (!target) return;
      var offset = target.getBoundingClientRect().top -
        scrollbox.getBoundingClientRect().top +
        scrollbox.scrollTop - 12;
      scrollbox.scrollTop = Math.max(0, offset);
    }

    function showGuide(anchor) {
      scrollbox.innerHTML = '<p class="cm-pg-guide-status" role="status">' + (document.documentElement.lang.toLowerCase().startsWith("en") ? 'Loading size guide…' : 'Caricamento guida alle taglie…') + '</p>';
      getGuide().then(function (source) {
        var content = source.cloneNode(true);
        var brand = anchor === "icon" || anchor === "ds2";
        var brandPanel = brand ? content.querySelector("#cm-sg-" + anchor) : null;
        content.querySelectorAll(".cm-sg-brand-panel").forEach(function (panel) {
          panel.classList.toggle("is-active", panel === brandPanel);
        });
        scrollbox.replaceChildren(content);
        scrollbox.scrollTop = 0;
        if (brandPanel) {
          scrollToGuideSection("cm-sg-" + anchor);
        } else if (anchor) {
          scrollToGuideSection("cm-sg-" + anchor);
        }
      }).catch(function () {
        var isEnglish = document.documentElement.lang.toLowerCase().startsWith("en");
        var guidePath = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/") + "pages/guida-alle-taglie";
        scrollbox.innerHTML =
          '<p class="cm-pg-guide-status" role="alert">' +
          (isEnglish ? 'The size guide could not be loaded here. ' : 'Non è stato possibile caricare la guida in questa finestra. ') +
          (isEnglish ? 'You can stay on this product or ' : 'Puoi restare sul prodotto oppure ') +
          '<a href="' + guidePath + '" target="_blank" rel="noopener">' +
          (isEnglish ? 'open the full size guide in a new tab' : 'aprire la guida in una nuova scheda') +
          '</a>.</p>';
      });
    }

    trigger.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      openDialog();
    });

    dialog.querySelectorAll("[data-cm-pg-close]").forEach(function (button) {
      button.addEventListener("click", closeDialog);
    });
    dialog.addEventListener("close", finishClose);
    dialog.addEventListener("cancel", function () {
      /* Escape closes the native dialog; the close event restores the product. */
    });
    dialog.addEventListener("click", function (event) {
      if (event.target === dialog) closeDialog();
    });
    scrollbox.addEventListener("click", function (event) {
      var link = event.target.closest("a[href^='#cm-sg']");
      if (!link) return;
      var targetId = (link.getAttribute("href") || "").slice(1);
      if (!/^(cm-sg|cm-sg-[a-z0-9-]+)$/.test(targetId)) return;
      event.preventDefault();
      scrollToGuideSection(targetId);
    });
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && dialog.open && typeof dialog.close !== "function") {
        closeDialog();
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize, { once: true });
  } else {
    initialize();
  }
})();